import { render } from "./templist.vue?vue&type=template&id=1f747ff0"
import script from "./templist.vue?vue&type=script&lang=js"
export * from "./templist.vue?vue&type=script&lang=js"

import "./templist.vue?vue&type=style&index=0&id=1f747ff0&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__